import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TrackChangeDetail} from '../../../shared/types/track-changes/track-changes';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'wsd-row-diff',
  templateUrl: './row-diff.component.html',
  styleUrls: ['./row-diff.component.css']
})
export class RowDiffComponent implements OnInit {

  @Input()
  update: boolean;

  @Input()
  translation: string;

  @Input()
  attribute: any;

  @Input()
  data: TrackChangeDetail;

  @Input()
  dateFlag: boolean;

  @Input()
  listFlag: boolean;

  @Input()
  listAtt: string;

  @Output()
  onVisibilityChange: EventEmitter<boolean> = new EventEmitter();

  oldData: JSON;

  newData: JSON;

  DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';

  constructor() {
  }

  ngOnInit() {
    if (this.data !== undefined) {
      this.newData = this.data.newData;
      this.oldData = this.data.oldData;
      this.checkIfAnyChangeIsDisplayed();
    }
  }

  checkIfAnyChangeIsDisplayed(): any {
    setTimeout(() => {
      if (this.update) {
        if (this.isDiff()) {
          this.onVisibilityChange.emit(true);
        }
      } else {
        if (this.getAnyData() !== null && this.getAnyData() !== '') {
          this.onVisibilityChange.emit(true);
        }
      }
    }, 100);
  }

  isDiff(): boolean {
    return this.getDataByAttribute(this.oldData) !== this.getDataByAttribute(this.newData);
  }

  getAnyData(): string {
    if (this.oldData === undefined || this.oldData === null) {
      return this.getDataByAttribute(this.newData);
    } else {
      return this.getDataByAttribute(this.oldData);
    }
  }

  getDataByAttribute(desiredData: JSON): string {
    if (this.dateFlag) {
      const parentObj = _.get(desiredData, this.attribute);
      if (parentObj == null) {
        return;
      }

      if (this.attribute === 'consentGivenDate') {
        return moment(parentObj).format('YYYY/MM/DD HH:mm:ss').toString();
      }
      const date: Date = new Date();
      date.setFullYear(parentObj['year'], parentObj['monthValue'], parentObj['dayOfMonth']);
      return moment(date).format(this.DEFAULT_DATE_FORMAT).toString();
    }
    if (this.listFlag) {
      const parentObj = _.get(desiredData, this.attribute);
      // @ts-ignore
      if (parentObj == null || parentObj.size === 0) {
        return null;
      }
      const arr = [];
      // @ts-ignore
      for (const a of parentObj) {
        arr.push(a[this.listAtt]);
      }
      return arr.join(' ');
    }
    return _.get(desiredData, this.attribute);
  }
}
